import { render, staticRenderFns } from "./download-center.vue?vue&type=template&id=5a684b8a&"
import script from "./download-center.vue?vue&type=script&lang=tsx&"
export * from "./download-center.vue?vue&type=script&lang=tsx&"
import style0 from "./download-center.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports